import { Suspense } from 'react'
import { Spinner } from '@/components/ui/Spinner'

// Lazy sayfalar için ortak Suspense fallback. Hem BrowserRouter (web) hem de
// masaüstü MDI AppRoutes aynı sarmalayıcıyı kullanır.
export function PageLoader() {
  return (
    <div className="flex items-center justify-center h-64">
      <Spinner size="lg" className="text-primary" />
    </div>
  )
}

export function S({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<PageLoader />}>{children}</Suspense>
}
